import React from 'react';
import { SideMenuItem, SideMenuSpacer }  from '../SidemenuItems';
import { Div } from '../../../../components/grid';

export default ({
  activeSidemenu,
}) => (
  <Div>
    <SideMenuItem to="/leverandoer-sodavand-kildevand-oel" title="Din leverandør af sodavand, kildevand & øl" active={activeSidemenu === 'Leverandoer'} main />
    <SideMenuSpacer />
    <SideMenuItem to="/antons-saft" title="Antons Saft" active={activeSidemenu === 'Antons'} />
    <SideMenuItem to="/cocio" title="Cocio" active={activeSidemenu === 'Cocio'} />
    <SideMenuItem to="/red-bull" title="Red Bull" active={activeSidemenu === 'RedBull'} />
    <SideMenuItem to="/soebogaard" title="Søbogaard" active={activeSidemenu === 'Soebogaard'} />
    <SideMenuItem to="/ice-tea" title="Ice Tea" active={activeSidemenu === 'IceTea'} />
    <SideMenuItem to="/juice" title="Juice" active={activeSidemenu === 'Juice'} />
  </Div>
);
